import React from 'react'
import { connect } from 'react-redux'

// Components
import Loader from '../../utils/Loader'
import ErrorText from '../../utils/error-success/ErrorText'
import SectionBanner from '../../utils/SectionBanner'
import SectionFooter from '../../utils/SectionFooter'
import TrainingPreviewItem from './TrainingPreviewItem'

// CSS
import '../../../css/sections/sections.css'

// State
import { getTraining } from '../../../store/actions/training'

class TrainingListing extends React.PureComponent {
	static initialAction(store, props, translationKey = null) {
		let res = store !== null ? getTraining(null, false, 3) : props.getTraining(null, false, 3)
		return res
	}

	componentDidMount() {
		if (!this.props.training.training) {
			TrainingListing.initialAction(null, this.props)
		}
	}

	renderItems = () => {
		const { training } = this.props.training

		if (!training || !training.length)
			return (
				<div className='padded-content'>
					<div className='strong-text'>
						No training scheduled at this time. Check back soon for further updates!
					</div>
				</div>
			)

		return training.map((item, id) => {
			return <TrainingPreviewItem key={id} item={item} />
		})
	}

	render() {
		const { translations } = this.props
		const { isLoading, error } = this.props.training

		return (
			<div className='section event-listing-box'>
				<SectionBanner bold={true}>{translations.sections.training_listing.title}</SectionBanner>
				{/* <div className='news-listing-content section-content--dark-bg'>
					{isLoading ? (
						<div className='section-content'>
							<Loader />
						</div>
					) : error ? (
						<div className='section-content'>
							<ErrorText errors={error} />
						</div>
					) : (
						this.renderItems()
					)}
				</div> */}
				<SectionFooter href='/training/education'>
					{translations.sections.training_listing.footer_link}
				</SectionFooter>
			</div>
		)
	}
}

const mapStateToProps = state => {
	return {
		translations: state.translations.translations,
		training: state.training,
	}
}

export default connect(mapStateToProps, { getTraining })(TrainingListing)



// WEBPACK FOOTER //
// ./src/components/home/training/TrainingListing.js